import coverDropzoneBackgroundSrc from 'src/modules/assets/placeholders/coverDropzoneBackground.svg';

export const coverDropzoneBackground = coverDropzoneBackgroundSrc;
